<aur-notice
  id="auth-verbiage-authorize-check"
  *ngIf="authVerbiageText"
  for="authorizeChecked"
  [severity]="severity"
  [icon]="icon"
  (click)="onAuthorizeChecked()"
>
  <span id="auth-verbiage-text" [innerText]="authVerbiageText"></span>
</aur-notice>
